import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lui-list-item',
    template: `
    <span class="list-item-icon-container">
      <ng-content select="[luiListItemIcon]"></ng-content>
    </span>
    <span class="list-item-content">
      <ng-content></ng-content>
    </span>
  `,
    standalone: false
})
export class ListItemComponent {
  @HostBinding('role') listItem = 'listitem';
  @HostBinding('class') className = 'list-item';
}
